import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Roadmap from './Roadmap';
import reportWebVitals from './reportWebVitals';
import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom';


ReactDOM.render(
  <React.StrictMode>
    <div className="swatch-1">
      <Router>
        <Roadmap path='/' component={Roadmap} exact/>

      </Router>
    </div>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
